import { Controller } from 'stimulus';

const REMOVE_MS = 250;
const PLACEHOLDER_DELAY_MS = 250;

export default class extends Controller {
  static targets = ['header'];

  connect() {
    if (this.#loading) {
      this.placeholderTimer = setTimeout(() => this.#show(), PLACEHOLDER_DELAY_MS);
    } else {
      this.#show();
    }
  }

  disconnect() {
    clearTimeout(this.removeTimer);
    clearTimeout(this.placeholderTimer);
    this.headerObserver?.disconnect();
  }

  headerTargetConnected(header) {
    this.headerObserver ??= new ResizeObserver(([entry]) =>
      this.#publishHeaderHeight(entry.target)
    );
    this.headerObserver.observe(header);
  }

  headerTargetDisconnected(header) {
    this.headerObserver?.unobserve(header);
  }

  loaded(event) {
    if (event.target === this.#panel) {
      this.#show();
    }
  }

  close() {
    this.element.close();
  }

  dismiss() {
    if (this.#dismissible) {
      this.close();
    }
  }

  cancel(event) {
    if (!this.#dismissible) {
      event.preventDefault();
    }
  }

  lock() {
    this.#setDismissible(false);
    this.element.focus();
  }

  unlock() {
    this.#setDismissible(true);
  }

  discard() {
    this.element.remove();
  }

  backdropMousedown(event) {
    this.fromBackdrop = event.target === this.element;
  }

  backdropClick(event) {
    const fromBackdrop = this.fromBackdrop;
    this.fromBackdrop = false;

    if (fromBackdrop && event.target === this.element) {
      this.dismiss();
    }
  }

  teardown() {
    this.dispatch('close', { bubbles: true });
    this.removeTimer = setTimeout(() => this.element.remove(), REMOVE_MS);
  }

  get #dismissible() {
    return !this.hasHeaderTarget || this.headerTarget.dataset.dismissible !== 'false';
  }

  #setDismissible(value) {
    if (this.hasHeaderTarget) {
      this.headerTarget.dataset.dismissible = value;
    }
  }

  #publishHeaderHeight(header) {
    this.element.style.setProperty('--twin-turbo-modal-header-height', `${header.offsetHeight}px`);
  }

  get #panel() {
    return this.element.querySelector(':scope > turbo-frame');
  }

  get #loading() {
    const panel = this.#panel;

    return !!panel?.src && !panel.hasAttribute('complete');
  }

  #show() {
    clearTimeout(this.placeholderTimer);

    if (!this.element.isConnected) {
      return;
    }

    if (this.element.matches(':modal')) {
      this.element.querySelector('[autofocus]')?.focus();
    } else {
      this.element.showModal();

      if (!this.element.querySelector('[autofocus]')) {
        this.element.focus();
      }
    }
  }
}
